require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./kriterien-nachmittagsbetreuung-2019-20.json") })
        }
      }, "path---kriterien-nachmittagsbetreuung-2019-20");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---kriterien-nachmittagsbetreuung-2019-20!./.cache/json/kriterien-nachmittagsbetreuung-2019-20.json
// module id = 1079
// module chunks = 231608221292675